import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            漫画<span className="text-primary-600">分类</span>
          </h2>
          <p className="text-sm text-foreground-500 mt-2">选择你感兴趣的韩漫分类，开启精彩阅读之旅</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-3 p-5 rounded-lg bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50 group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${cat.icon} text-xl text-primary-500`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}